import { useEffect, useState } from "react";

// ui
import { Box, Alert } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { OutSideStartStopModal } from "../component/tableFunction/OutSideStartStopModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getOutsideEntrySites,
  getOutsideEntrySite,
  postOutsideEntrySite,
  putOutsideEntrySite,
  checkPostOutsideEntrySite,
  putOutsideEntrySiteSiteClose,
} from "../api/outsideEntrySite";
import {
  getOutsideEntrySitePDFs,
  getOutsideEntrySitePDF,
  postOutsideEntrySitePDF,
  putOutsideEntrySitePDF,
  deleteOutsideEntrySitePDF,
  checkPostOutsideEntrySitePDF,
} from "../api/outsideEntrySitePDF";
import { getOutsideEntrySiteAccounts } from "../api/outsideEntrySiteAccount";
import { getOutsideEntrySitePaymentMethods } from "../api/outsideEntrySitePaymentMethod";
import {
  getOutsideEntrySiteCancellChatApps,
  getOutsideEntrySiteCancellChatApp,
  postOutsideEntrySiteCancellChatApp,
  putOutsideEntrySiteCancellChatApp,
  deleteOutsideEntrySiteCancellChatApp,
} from "../api/outsideEntrySiteCancellChatApp";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getProductCandidatesEntry,
} from "../api/serch";
import {
  postPresignedPost,
  getPresignedPostOutsideFile,
} from "../api/presignedURL";

// InterFace
import { outsideEntrySiteTableColumn } from "../config/outsideEntrySite";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function OutsideEntrySite() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "外部ETサイト登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "外部ETサイト登録") {
      setAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name == "PDF一覧") {
      getSubtableDataPDF();
    }
    if (getSubTableName.name === "解約チャットアプリ連携一覧") {
      getSubtableDataOutsideEntrySiteCancellChatApp();
    }
    if (getSubTableName.name == "アカウント一覧") {
      getSubtableDataAccount();
    }
    if (getSubTableName.name == "独自決済一覧") {
      getSubtableDataPaymentMethod();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "PDF詳細") {
      getSubtableDataDetailPDF();
    }
    if (getSubTableDetail.name === "解約チャットアプリ連携詳細") {
      getDataDetailOutsideEntrySiteCancellChatApp();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルの一覧をメインテーブルの詳細表示（エントリーフォーム用）
  const [getSubMainTableDetail, setGetSubMainTableName] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {}, [getSubMainTableDetail.name, getSubMainTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "PDF追加") {
      openModalSubtableDataAddPDF();
    }
    if (
      getSubTableAdd.name === "解約チャットアプリ連携追加" &&
      getSubTableAdd.row
    ) {
      setAddOutsideEntrySiteCancellChatApp({
        ...addOutsideEntrySiteCancellChatApp,
        outside_entry_site_id: String(getSubTableAdd.row.id),
      });
      setOnOutsideEntrySiteCancellChatAppAddModal(true);
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "公開・非公開") {
      setStartStopDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "PDF一覧") {
      setDeletePDFDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "削除") {
      setDeleteCancellChatAppInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = outsideEntrySiteTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
            no_entry_flg: "通常",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
            no_entry_flg: "通常",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
            no_entry_flg: "通常",
          };
        }
      } else {
        return {
          ...column,
          no_entry_flg: "通常",
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getOutsideEntrySites({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.outsideEntrySites);
      const countOutsideEntrySites = Number(fetchData.countOutsideEntrySites);
      setTotalCount(countOutsideEntrySites);
      setMaxPageNumber(Math.ceil(countOutsideEntrySites / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 商材詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getOutsideEntrySite(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }
  // 商材編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      if (
        editData.editType === "outside_site_logo" ||
        editData.editType === "outside_site_favicon"
      ) {
        // サイトロゴ、faviconの場合、事前にファイル格納
        if (editData.customer_picture) {
          const fileName = editData.customer_picture.name;
          const { presigned_object, destination_key } =
            await getPresignedPostOutsideFile(
              editData.editType,
              editData.value as string,
              fileName,
            );
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editData.customer_picture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          const putResponce = await putOutsideEntrySite({
            ...editData,
            editValue: destination_key,
          });
          await getDataDetail({ id }, true);
          await getTableData(true);
          setEditData({
            ...editData,
            editValue: destination_key,
            status: putResponce,
          });
          setIsLoading(false);
        }
      } else {
        const putResponce = await putOutsideEntrySite(editData);
        await getDataDetail({ id }, true);
        await getTableData(true);
        setEditData({
          ...editData,
          status: putResponce,
        });
        setIsLoading(false);
      }
    }
  }

  // 商材新規作成
  const addDataColumns = outsideEntrySiteTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.key === "payment_method") {
          return {
            ...column,
            [difine.key]: [""],
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onAddModal, setAddModal] = useState(false);
  const [postFiles, setPostFiles] = useState<{
    [key: string]: File;
  }>({});

  async function postAddData() {
    setIsLoading(true);
    setAddModal(false);
    // 事前にパスの重複の確認 & データ保存用著名付きURL作成
    const site_favicon_name = postFiles.site_favicon.name;
    const site_logo_name = postFiles.site_logo.name;
    const {
      checkPostResponce,
      presigned_favicon_object,
      destination_favicon_key,
      presigned_logo_object,
      destination_logo_key,
    } = await checkPostOutsideEntrySite(
      addData,
      site_favicon_name,
      site_logo_name,
    );
    if (
      checkPostResponce === "success" &&
      presigned_favicon_object &&
      destination_favicon_key &&
      presigned_logo_object &&
      destination_logo_key
    ) {
      // ファイル（ロゴ、favicon）の登録
      const formData_favicon = new FormData();
      for (const key in presigned_favicon_object.fields) {
        formData_favicon.append(key, presigned_favicon_object.fields[key]);
      }
      formData_favicon.append("file", postFiles.site_favicon);
      postPresignedPost(presigned_favicon_object.url, formData_favicon);
      const formData_logo = new FormData();
      for (const key in presigned_logo_object.fields) {
        formData_logo.append(key, presigned_logo_object.fields[key]);
      }
      formData_logo.append("file", postFiles.site_logo);
      postPresignedPost(presigned_logo_object.url, formData_logo);
      // データ登録
      const postResponce = await postOutsideEntrySite({
        ...addData,
        site_favicon: destination_favicon_key,
        site_logo: destination_logo_key,
      });
      if (postResponce === "success") {
        await getTableData(true);
        setAddData(addDataColumns);
        setOnDataAddModalResult("success");
      } else {
        setAddModal(true);
        setOnDataAddModalResult(postResponce);
      }
    } else {
      setAddModal(true);
      setOnDataAddModalResult("サイトパスが重複しています。");
    }
    setIsLoading(false);
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // PDF一覧取得
  async function getSubtableDataPDF() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntrySitePDFs(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 解約チャットアプリ連携一覧取得
  async function getSubtableDataOutsideEntrySiteCancellChatApp() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntrySiteCancellChatApps(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 解約チャットアプリ連携詳細取得
  async function getDataDetailOutsideEntrySiteCancellChatApp() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getOutsideEntrySiteCancellChatApp(
        getSubTableDetail.key.id,
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail: dataDetail,
      });
      setIsLoading(false);
    }
  }

  // PDF詳細取得
  async function getSubtableDataDetailPDF() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getOutsideEntrySitePDF(getSubTableDetail.key.id);
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // PDF編集
  const [editDataDetailPDF, setEditDataDetailPDF] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailPDF() {
    if (editDataDetailPDF !== null) {
      setIsLoading(true);
      setEditDataDetailPDF({
        ...editDataDetailPDF,
        status: "editing",
      });
      if (editDataDetailPDF.editType === "site_pdf_path") {
        // PDFファイルの場合、事前にファイル格納
        if (editDataDetailPDF.customer_picture) {
          const fileName = editDataDetailPDF.customer_picture.name;
          const { presigned_object, destination_key } =
            await getPresignedPostOutsideFile(
              editDataDetailPDF.editType,
              editDataDetailPDF.value as string,
              fileName,
            );
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editDataDetailPDF.customer_picture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          const putResponce = await putOutsideEntrySitePDF({
            ...editDataDetailPDF,
            editValue: destination_key,
          });
          if (putResponce == "success") {
            await getSubtableDataPDF();
            await getSubtableDataDetailPDF();
          }
          setEditDataDetailPDF({
            ...editDataDetailPDF,
            editValue: destination_key,
            status: putResponce,
          });
          setIsLoading(false);
        }
      } else {
        const putResponce = await putOutsideEntrySitePDF(editDataDetailPDF);
        if (putResponce == "success") {
          await getSubtableDataPDF();
          await getSubtableDataDetailPDF();
        }
        setEditDataDetailPDF({
          ...editDataDetailPDF,
          status: putResponce,
        });
        setIsLoading(false);
      }
    }
  }

  // PDF新規登録
  const addDataColumnsPDF =
    outsideEntrySiteTableColumn.subTable[0].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      },
      {},
    );
  const [addDataPDF, setAddDataPDF] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsPDF);
  const [postPDFFiles, setPostPDFFiles] = useState<{
    [key: string]: File;
  }>({});

  const [onDataAddModalPDF, setOnDataAddModalPDF] = useState(false);
  async function openModalSubtableDataAddPDF() {
    let _addDataPDF = addDataPDF;
    outsideEntrySiteTableColumn.subTable[0].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataPDF[difine.key] = getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataPDF[difine.key] = getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataPDF[difine.key] = getSubTableAdd.row[difine.key] as string;
        }
      }
    });
    setAddDataPDF(_addDataPDF);
    if (getSubTableAdd.row) {
      setOnDataAddModalPDF(true);
    }
  }
  async function postAddDataPDF() {
    setIsLoading(true);
    setOnDataAddModalPDF(false);
    // 事前にパスの重複の確認 & データ保存用著名付きURL作成
    const site_pdf_path_name = postPDFFiles.site_pdf_path.name;
    const {
      checkPostResponce,
      presigned_pdf_path_object,
      destination_pdf_path_key,
    } = await checkPostOutsideEntrySitePDF(addDataPDF, site_pdf_path_name);
    if (
      checkPostResponce === "success" &&
      presigned_pdf_path_object &&
      destination_pdf_path_key
    ) {
      // ファイル（pdf_path）の登録
      const formData_pdf_path = new FormData();
      for (const key in presigned_pdf_path_object.fields) {
        formData_pdf_path.append(key, presigned_pdf_path_object.fields[key]);
      }
      formData_pdf_path.append("file", postPDFFiles.site_pdf_path);
      postPresignedPost(presigned_pdf_path_object.url, formData_pdf_path);
      // データ登録
      const postResponce = await postOutsideEntrySitePDF({
        ...addDataPDF,
        site_pdf_path: destination_pdf_path_key,
      });
      if (postResponce === "success") {
        if (getSubTableName.name == "PDF一覧") {
          await getSubtableDataPDF();
        }
        await getTableData(true);
        setAddDataPDF(addDataColumnsPDF);
        setOnSubtableDataAddModalResult("success");
      } else {
        setOnDataAddModalPDF(true);
        setOnSubtableDataAddModalResult(postResponce);
      }
    } else {
      setOnDataAddModalPDF(true);
      setOnSubtableDataAddModalResult(
        "同一パス内でPDFファイル名が重複しています。",
      );
    }
    setIsLoading(false);
  }

  // 解約チャットアプリ連携編集
  const [
    editOutsideEntrySiteCancellChatApp,
    setEditOutsideEntrySiteCancellChatApp,
  ] = useState<EditDataDifine | null>(null);
  async function putEditOutsideEntrySiteCancellChatApp() {
    if (editOutsideEntrySiteCancellChatApp !== null) {
      const id = editOutsideEntrySiteCancellChatApp.tableId as string;
      setIsLoading(true);
      setEditOutsideEntrySiteCancellChatApp({
        ...editOutsideEntrySiteCancellChatApp,
        status: "editing",
      });
      const putResponce = await putOutsideEntrySiteCancellChatApp(
        editOutsideEntrySiteCancellChatApp,
      );
      if (putResponce == "success") {
        await getSubtableDataOutsideEntrySiteCancellChatApp();
        await getDataDetailOutsideEntrySiteCancellChatApp();
        await getTableData(true);
      }
      setEditOutsideEntrySiteCancellChatApp({
        ...editOutsideEntrySiteCancellChatApp,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 解約チャットアプリ連携追加
  const [
    onOutsideEntrySiteCancellChatAppAddModal,
    setOnOutsideEntrySiteCancellChatAppAddModal,
  ] = useState(false);
  const [
    addOutsideEntrySiteCancellChatApp,
    setAddOutsideEntrySiteCancellChatApp,
  ] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    outside_entry_site_id: "",
    cancell_sns_type: "",
    cancell_sns_id: "",
    cancell_sns_haeder: "",
    cancell_sns_footer: "",
  });
  async function postAddOutsideEntrySiteCancellChatApp() {
    setIsLoading(true);
    setOnOutsideEntrySiteCancellChatAppAddModal(false);
    const postResponce = await postOutsideEntrySiteCancellChatApp(
      addOutsideEntrySiteCancellChatApp,
    );
    if (postResponce === "success") {
      await getTableData(true);
      await getSubtableDataOutsideEntrySiteCancellChatApp();
      setAddOutsideEntrySiteCancellChatApp({
        outside_entry_site_id: "",
        cancell_sns_type: "",
        cancell_sns_id: "",
        cancell_sns_haeder: "",
        cancell_sns_footer: "",
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnOutsideEntrySiteCancellChatAppAddModal(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 解約チャットアプリ連携の削除
  const [deleteCancellChatAppInf, setDeleteCancellChatAppInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteCancellChatApp() {
    setDeleteCancellChatAppInf({
      ...deleteCancellChatAppInf,
      status: "loading",
    });
    const id = deleteCancellChatAppInf.key.id;
    const responce = await deleteOutsideEntrySiteCancellChatApp(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataOutsideEntrySiteCancellChatApp();
      setDeleteCancellChatAppInf({
        ...deleteCancellChatAppInf,
        status: "success",
      });
    } else {
      setDeleteCancellChatAppInf({
        ...deleteCancellChatAppInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteCancellChatAppInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteCancellChatAppInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteCancellChatAppInf]);

  // 支払方法一覧取得
  async function getSubtableDataPaymentMethod() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntrySitePaymentMethods(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーアカウント一覧取得
  async function getSubtableDataAccount() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntrySiteAccounts(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 取扱い停止・再開
  const [startStopDataInf, setStartStopDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function startStopData() {
    setStartStopDataInf({
      ...startStopDataInf,
      status: "loading",
    });
    const id = startStopDataInf.key.id;
    const startStop = startStopDataInf.key.startStop;
    const responce = await putOutsideEntrySiteSiteClose(id, startStop);
    if (responce == "success") {
      await getTableData(false);
      setStartStopDataInf({
        ...startStopDataInf,
        status: "success",
      });
    } else {
      setStartStopDataInf({
        ...startStopDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (startStopDataInf.status === "loading") {
      setIsLoading(true);
    } else if (startStopDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [startStopDataInf]);

  // PDF削除
  const [deletePDFDataInf, setDeletePDFDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deletePDFData() {
    setDeletePDFDataInf({
      ...deletePDFDataInf,
      status: "loading",
    });
    const id = deletePDFDataInf.key.id;
    const responce = await deleteOutsideEntrySitePDF(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataPDF();
      setDeletePDFDataInf({
        ...deletePDFDataInf,
        status: "success",
      });
    } else {
      setDeletePDFDataInf({
        ...deletePDFDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deletePDFDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deletePDFDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deletePDFDataInf]);

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
    }
  }
  async function getProductNameListFromHistory() {
    const products = await getProductCandidatesEntry();
    if (products) {
      const names: string[] = [""];
      for (const p of products) {
        if (p.product_name && !names.includes(p.product_name)) {
          names.push(p.product_name);
        }
      }
      setProductNameList(names);
    }
  }
  // サービス新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(addData.high_rank_company_id);
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addData]);

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getProductNameListFromHistory();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : serchOpen || aiChatOpen
            ? "calc(100% - 331px)"
            : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }} data-testid="outside-entry-site-page">
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={outsideEntrySiteTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={setGetSubSubTableAdd}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={outsideEntrySiteTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={setGetSubMainTableName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={outsideEntrySiteTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={[]}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="OutsideEntrySite"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={outsideEntrySiteTableColumn.detailTitle}
        editAuth={outsideEntrySiteTableColumn.editAuth}
        dataColumn={outsideEntrySiteTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            outsideEntrySiteTableColumn.subTable[0].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailPDF !== null &&
            editDataDetailPDF.status !== "editing") ||
            editDataDetailPDF === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={
          outsideEntrySiteTableColumn.subTable[0].subTableDetailTitle
        }
        editAuth={outsideEntrySiteTableColumn.subTable[0].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={outsideEntrySiteTableColumn.subTable[0].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailPDF}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={categoryList}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailPDF !== null && editDataDetailPDF.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailPDF(null)}
        editData={editDataDetailPDF}
        setEditData={setEditDataDetailPDF}
        putEditData={putEditDataDetailPDF}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onAddModal}
        swCloseModal={() => {
          setAddModal(false);
          setPostFiles({});
          setAddDataName("");
        }}
        addTitle={outsideEntrySiteTableColumn.addTitle}
        dataColumn={outsideEntrySiteTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={[]}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={categoryList}
        groupList={[]}
        postFiles={postFiles}
        setPostFiles={setPostFiles}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setPostFiles({});
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModal
        onModal={onDataAddModalPDF}
        swCloseModal={() => {
          setOnDataAddModalPDF(false);
          setPostPDFFiles({});
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={outsideEntrySiteTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntrySiteTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataPDF}
        addData={addDataPDF}
        setAddData={setAddDataPDF}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={postPDFFiles}
        setPostFiles={setPostPDFFiles}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <OutSideStartStopModal
        onModal={
          startStopDataInf.status !== null &&
          startStopDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setStartStopDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        startStopDataInf={startStopDataInf}
        setStartStopDataInf={setStartStopDataInf}
        startStopData={startStopData}
      />
      <DataDeleteModal
        onModal={
          deletePDFDataInf.status !== null &&
          deletePDFDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeletePDFDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deletePDFDataInf}
        setDeleteDataInf={setDeletePDFDataInf}
        deleteData={deletePDFData}
        labels={{
          title: "PDF設定削除",
          confirmBody: (
            <Alert severity="error">
              PDF設定削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "PDF設定削除",
          successMessage: "PDF設定の削除に成功しました。",
        }}
      />
      {/* 解約チャットアプリ連携 詳細 */}
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            outsideEntrySiteTableColumn.subTable[1].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editOutsideEntrySiteCancellChatApp !== null &&
            editOutsideEntrySiteCancellChatApp.status !== "editing") ||
            editOutsideEntrySiteCancellChatApp === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={
          outsideEntrySiteTableColumn.subTable[1].subTableDetailTitle
        }
        editAuth={outsideEntrySiteTableColumn.subTable[1].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={outsideEntrySiteTableColumn.subTable[1].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditOutsideEntrySiteCancellChatApp}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      {/* 解約チャットアプリ連携 編集 */}
      <DataEditModal
        onModal={
          editOutsideEntrySiteCancellChatApp !== null &&
          editOutsideEntrySiteCancellChatApp.status !== "editing"
        }
        swCloseModal={() => setEditOutsideEntrySiteCancellChatApp(null)}
        editData={editOutsideEntrySiteCancellChatApp}
        setEditData={setEditOutsideEntrySiteCancellChatApp}
        putEditData={putEditOutsideEntrySiteCancellChatApp}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      {/* 解約チャットアプリ連携 追加 */}
      <DataAddModal
        onModal={onOutsideEntrySiteCancellChatAppAddModal}
        swCloseModal={() => {
          setOnOutsideEntrySiteCancellChatAppAddModal(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
          setAddOutsideEntrySiteCancellChatApp({
            outside_entry_site_id: "",
            cancell_sns_type: "",
            cancell_sns_id: "",
            cancell_sns_haeder: "",
            cancell_sns_footer: "",
          });
        }}
        addTitle={outsideEntrySiteTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntrySiteTableColumn.subTable[1].subDataColumn}
        postAddData={postAddOutsideEntrySiteCancellChatApp}
        addData={addOutsideEntrySiteCancellChatApp}
        setAddData={setAddOutsideEntrySiteCancellChatApp}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      {/* 登録結果（PDF追加・解約チャットアプリ連携追加）は登録モーダルより後に記述して上に表示 */}
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setPostPDFFiles({});
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      {/* 解約チャットアプリ連携 削除 */}
      <DataDeleteModal
        onModal={
          deleteCancellChatAppInf.status !== null &&
          deleteCancellChatAppInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteCancellChatAppInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteCancellChatAppInf}
        setDeleteDataInf={setDeleteCancellChatAppInf}
        deleteData={deleteCancellChatApp}
        labels={{
          title: "解約チャットアプリ連携削除",
          confirmBody: (
            <Alert severity="error">
              解約チャットアプリ連携削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "解約チャットアプリ連携の削除に成功しました。",
        }}
      />
    </Box>
  );
}

export default OutsideEntrySite;
